module.exports = __webpack_public_path__ + "img/view_explanation_4.46fa7f37.png";